import styled from '@emotion/styled';

export const ShowMeHowContainer = styled.div`
  width: 230px;
  padding: 25px;
  height: 105px;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  box-shadow: 0 1px 7px 0 rgba(0, 105, 250, 0.32);
  background-color: #ffffff;
  cursor: pointer;
`;

export const ShowMeHowImageDescription = styled.span`
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: ${({ theme }) => theme.lineHeight.medium};
  letter-spacing: normal;
  margin-left: 16px;
  color: #233b69;
`;

export const ShowMeHowTextContainer = styled.span`
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: center;
  color: #233b69;
`;

export const ShowMeHowDContainer = styled.div`
  width: 100%;
  display: block;
  margin-top: 8px;
  justify-content: center;
  text-align: center;
`;
